import React from 'react'
import { ROOT_DOMAIN } from '../lib/tenants'

/**
 * Shown when the host is `<slug>.codeblacksda.com` but `<slug>` is not in the tenant
 * registry. Deliberately standalone — imports no Supabase/Refine code, so it renders
 * without booting the app for an unconfigured tenant.
 */
export function UnknownOrganization({ slug }: { slug: string }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        color: '#1e293b',
        textAlign: 'center',
        padding: 24,
      }}
    >
      {/* Neutral emblem — no tenant resolves for an unknown slug, so we never
          brand this page with a specific school's crest. Decorative only. */}
      <svg width={72} height={72} viewBox="0 0 72 72" fill="none" aria-hidden="true" focusable="false">
        <circle cx="36" cy="36" r="34" fill="#f1f5f9" stroke="#cbd5e1" strokeWidth="2" />
        <path
          d="M24 48V30l12-8 12 8v18"
          stroke="#94a3b8"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <path
          d="M32 48v-8h8v8"
          stroke="#94a3b8"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line x1="20" y1="48" x2="52" y2="48" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <h1 style={{ margin: 0, fontSize: 24 }}>Unknown organization</h1>
      <p style={{ margin: 0, maxWidth: 420 }}>
        No alumni workspace is configured for <strong>{`${slug}.${ROOT_DOMAIN}`}</strong>.
      </p>
      <p style={{ margin: 0, color: '#64748b' }}>
        Check the address, or contact your administrator.
      </p>
    </div>
  )
}
